import { Component } from '@angular/core';

@Component({
  selector: 'app-test-device',
  templateUrl: './test-device.component.html',
  styleUrls: ['./test-device.component.scss'],
  standalone: false,
})
export class TestDeviceComponent {
  constructor() {}
}
